import {Roles} from 'app/Constants';
import {Column} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import IntegrityRoleGrid from '../../../components/UserRole';
import {useIntegrityProfile} from '../hooks';

const IntegrityProfileGrid = (props: any) => {
  const loadProfiles = useIntegrityProfile(props.data.key);

  return (
    <IntegrityRoleGrid
      allowEdit={Roles.AdminITPS}
      dataSource={loadProfiles}
      id={['iD_Profile']}
      height={'30vh'}
      allowIntegrity={false}
      allowActions={false}
      disabledExport={true}
      autoWidth={false}
    >
      <Column
        caption={i18n2._('#Profile')}
        hidingPriority={0}
        dataField="iD_Profile"
      />
      <Column caption={i18n2._('Nombre')} dataField="name" width={200} />
      <Column
        caption={i18n2._('#Sector')}
        hidingPriority={1}
        dataField="iD_Sector"
        width={100}
      />
      <Column caption={i18n2._('Nombre del sector')} dataField="sector_Name" />
      <Column caption={i18n2._('Revision')} dataField="revision" width={100} />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        defaultSortOrder={'desc'}
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default IntegrityProfileGrid;
